import { Link } from "react-router";
import type { Identifier } from "ra-core";
import { useGetList, useTranslate } from "ra-core";

import { Button } from "@/components/ui/button";
import type { Agreement } from "./agreementData";
import { AgreementRows } from "./AgreementPages";
import { useAgreementWarnings } from "./useAgreementWarnings";

// Agreements of a contact or a company (task 1.10): on the phone this is
// the way to them, there is no bottom bar button.
export const RelatedAgreements = ({
  target,
  targetId,
}: {
  target: "contact" | "company";
  targetId: Identifier;
}) => {
  const translate = useTranslate();
  const filterKey = target === "contact" ? "contact_id" : "company_id";
  const { data: agreements = [] } = useGetList<Agreement>("agreements", {
    pagination: { page: 1, perPage: 50 },
    sort: { field: "id", order: "DESC" },
    filter: { [filterKey]: targetId },
  });
  const warningsOf = useAgreementWarnings(agreements.map((item) => item.id));
  return (
    <section
      aria-label={translate("resources.agreements.name", { smart_count: 2 })}
      className="flex flex-col gap-2"
    >
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold">
          {translate("resources.agreements.name", { smart_count: 2 })}
        </h3>
        <Button variant="outline" size="sm" asChild>
          <Link to={`/agreements/create?${filterKey}=${targetId}`}>
            {translate("tenax.agreements.new")}
          </Link>
        </Button>
      </div>
      {agreements.length ? (
        <AgreementRows agreements={agreements} warningsOf={warningsOf} />
      ) : null}
    </section>
  );
};
